module.exports = __webpack_public_path__ + "static/assets/88af8497f87cce3029158003cbad1ec4.svg";